/**
 * Public URL of the store-update manifest in R2.
 *
 * The reader is anonymous — the client fetches this directly without going through the API.
 * That is the whole point of the R2-static shape: reads survive backend outages, and edge
 * caching makes the resume-check nearly free. Admin writes still go through the API
 * (`PUT /api/admin/store-updates`), which is the single writer.
 *
 * Overridable via `VITE_STORE_UPDATE_MANIFEST_URL` so a preview/staging deploy can point at a
 * different R2 object. Falls back to the production downloads bucket key.
 */

export const STORE_UPDATE_MANIFEST_URL: string =
  import.meta.env.VITE_STORE_UPDATE_MANIFEST_URL ??
  'https://downloads.gotradeloop.com/store-updates/latest.json';
